import type { IconProps } from "@lib/common/components/Icon/Icon";
import Icon from "@lib/common/components/Icon/Icon";
import { useMantineColorScheme } from "@mantine/core";

export default function AgentIcon({ ...props }: Pick<IconProps, "size">) {
  const { colorScheme } = useMantineColorScheme();
  return <Icon name="face-disguise" variant={colorScheme === "light" ? "light" : "solid"} {...props} />;
}
